var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDayNight02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3779 6.51055C4.5581 4.99219 4.81212 3.18518 5.87151 1.94971C5.39233 2.01033 4.91604 2.15466 4.46573 2.40002C2.49706 3.46229 1.76098 5.91879 2.82613 7.89035C3.89129 9.8619 6.3478 10.5951 8.31646 9.53283C8.76678 9.29035 9.15069 8.96994 9.46534 8.60334C7.84883 8.81118 6.20058 8.03179 5.38078 6.51055H5.3779Z",
    fill: "#3284FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDayNight02);
export default __webpack_public_path__ + "static/media/i_day_night_02.326ebf74e2a4eec626625ef53425ff9b.svg";
export { ForwardRef as ReactComponent };